var _effectorFileName = "/src/page-content/home/components/numbers/numbers.tsx";
import { Article } from '@/shared/components/article';
import { NumberTicker } from '@/shared/components/number-ticker';
import { Card } from '@/shared/components/ui/card';
import { cn } from '@/shared/lib/cn';
export const Numbers = () => {
  return <Article>
      <h2 className="mb-8 header-h2">Our Numbers</h2>

      <div className="grid grid-cols-1 gap-x-4 gap-y-12 md:grid-cols-3 md:gap-x-6">
        <Card className={cn('group relative mx-auto grid w-full grid-rows-[auto,1fr] justify-between overflow-hidden rounded-xl px-4 py-6 pb-8 sm:px-10 sm:py-10 md:gap-2',
      // light styles
      'bg-white [box-shadow:0_0_0_1px_rgba(0,0,0,.03),0_2px_4px_rgba(0,0,0,.05),0_12px_24px_rgba(0,0,0,.05)]',
      // dark styles
      'transform-gpu dark:bg-black dark:[border:1px_solid_rgba(255,255,255,.1)] dark:[box-shadow:0_-20px_80px_-20px_#ffffff1f_inset]')}>
          <div className="w-full text-base font-semibold sm:text-lg">
            &gt;&nbsp;
            <NumberTicker className="inline" value={700} />
          </div>

          <div className="flex-1">
            <h3 className="mb-2 header-h3">Students</h3>
            <p className="text-sm text-muted-foreground">
              More than 700 students have improved their language skills with us
            </p>
          </div>
        </Card>

        <Card className={cn('group relative mx-auto grid w-full grid-rows-[auto,1fr] justify-between overflow-hidden rounded-xl px-4 py-6 pb-8 sm:px-10 sm:py-10 md:gap-2',
      // light styles
      'bg-white [box-shadow:0_0_0_1px_rgba(0,0,0,.03),0_2px_4px_rgba(0,0,0,.05),0_12px_24px_rgba(0,0,0,.05)]',
      // dark styles
      'transform-gpu dark:bg-black dark:[border:1px_solid_rgba(255,255,255,.1)] dark:[box-shadow:0_-20px_80px_-20px_#ffffff1f_inset]')}>
          <div className="w-full max-w-[25%] text-base font-semibold sm:text-lg xl:max-w-[20%]">
            <NumberTicker value={17} />
          </div>

          <div className="flex-1">
            <h3 className="mb-2 header-h3">Teachers</h3>
            <p className="text-sm text-muted-foreground">
              We&nbsp;train employees from&nbsp;IT, oil &amp;&nbsp;gas, tourism, career consulting, legal industries and
              others
            </p>
          </div>
        </Card>

        <Card className={cn('group relative mx-auto grid w-full grid-rows-[auto,1fr] justify-between overflow-hidden rounded-xl px-4 py-6 pb-8 sm:px-10 sm:py-10 md:gap-2',
      // light styles
      'bg-white [box-shadow:0_0_0_1px_rgba(0,0,0,.03),0_2px_4px_rgba(0,0,0,.05),0_12px_24px_rgba(0,0,0,.05)]',
      // dark styles
      'transform-gpu dark:bg-black dark:[border:1px_solid_rgba(255,255,255,.1)] dark:[box-shadow:0_-20px_80px_-20px_#ffffff1f_inset]')}>
          <div className="w-full text-base font-semibold sm:text-lg">
            &gt;&nbsp;
            <NumberTicker className="inline" value={8000} />
          </div>

          <div className="flex-1">
            <h3 className="mb-2 header-h3">Hours</h3>
            <p className="text-sm text-muted-foreground">
              Our teachers have invested over 8,000 hours helping our students master English.
            </p>
          </div>
        </Card>
      </div>
    </Article>;
};